import { render } from "./indexPage.vue?vue&type=template&id=06d0dae8&scoped=true"
import script from "./indexPage.vue?vue&type=script&lang=js"
export * from "./indexPage.vue?vue&type=script&lang=js"

import "./indexPage.vue?vue&type=style&index=0&id=06d0dae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d0dae8"]])

export default __exports__